import { render } from "./AddTestDialog.vue?vue&type=template&id=23b322c5&scoped=true"
import script from "./AddTestDialog.vue?vue&type=script&lang=js"
export * from "./AddTestDialog.vue?vue&type=script&lang=js"

import "./AddTestDialog.vue?vue&type=style&index=0&id=23b322c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b322c5"]])

export default __exports__